import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
} from "@chakra-ui/react";
import { translate as trans } from "../Trans/Trans";

const ConfirmDangerModal = ({
  confirmTitle,
  confirmMessage,
  confirmButtonText,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const cancelRef = useRef();

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          {confirmTitle ? (
            <AlertDialogHeader fontSize="lg">{confirmTitle}</AlertDialogHeader>
          ) : null}
          {confirmMessage ? (
            <AlertDialogBody>{confirmMessage}</AlertDialogBody>
          ) : null}
          <AlertDialogFooter>
            <ButtonGroup size="sm" spacing="3">
              <Button ref={cancelRef} onClick={onClose}>
                {trans("generic.cancel")}
              </Button>
              <Button variant="danger" onClick={onConfirm}>
                {confirmButtonText || trans("generic.confirm")}
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

ConfirmDangerModal.propTypes = {
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
  confirmButtonText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
};

ConfirmDangerModal.defaultProps = {
  confirmTitle: undefined,
  confirmMessage: undefined,
  confirmButtonText: undefined,
  onConfirm: undefined,
  isOpen: undefined,
};

export default ConfirmDangerModal;
